import React from 'react';
import { useTransition, animated, config } from '@react-spring/web';
import useViewports from '../../Hooks/useViewports';

interface ProductAnimationContainerProps {
  items: any[];
  renderItem: (item: any, index: number) => React.ReactNode;
  view: string;
}

const ProductAnimationContainer: React.FC<ProductAnimationContainerProps> = ({
  items,
  renderItem,
  view,
}) => {
  const { xs, sm, md } = useViewports();
  const isMobile = xs || sm || md;

  const transitions = useTransition(items || [], {
    from: {
      opacity: 0,
      transform: `translate3d(0, ${isMobile ? '20px' : '30px'}, 0)`,
    },
    enter: { opacity: 1, transform: 'translate3d(0, 0px, 0)' },
    trail: isMobile ? 0 : 30,
    config: isMobile
      ? config.stiff
      : { ...config.gentle, tension: 200, friction: 30 },
    keys: (item: any) => `${view}-${item.id || item.erp_id}`,
  });

  return (
    <>
      {transitions((style, item, _, index) => (
        <animated.div style={style}>{renderItem(item, index)}</animated.div>
      ))}
    </>
  );
};

export default ProductAnimationContainer;
